import { render, staticRenderFns } from "./MemberInvite.vue?vue&type=template&id=854f916c&scoped=true&"
import script from "./MemberInvite.vue?vue&type=script&lang=js&"
export * from "./MemberInvite.vue?vue&type=script&lang=js&"
import style0 from "./MemberInvite.vue?vue&type=style&index=0&id=854f916c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854f916c",
  null
  
)

export default component.exports